//#region src/shared/known-error-code/known-error.code.ts
let KnownErrorCode = /* @__PURE__ */ function(KnownErrorCode$1) {
	KnownErrorCode$1["DigitalRxUnclaimed"] = "DigitalRxUnclaimed";
	KnownErrorCode$1["DigitalRxClaimed"] = "DigitalRxClaimed";
	KnownErrorCode$1["VerifyDoesNotMatch"] = "VerifyDoesNotMatch";
	KnownErrorCode$1["Unauthorized"] = "Unauthorized";
	KnownErrorCode$1["Forbidden"] = "Forbidden";
	KnownErrorCode$1["InternalServerError"] = "InternalServerError";
	KnownErrorCode$1["MedicationIsUnclaimed"] = "MedicationIsUnclaimed";
	KnownErrorCode$1["NotFound"] = "NotFound";
	return KnownErrorCode$1;
}({});
const isKnownErrorCode = (code) => {
	return !!KnownErrorCode[code];
};

//#endregion
export { KnownErrorCode, isKnownErrorCode };